export enum DATA_FETCH_STATUS{
    NONE = 0,
    LOADING,
    LOADED,
    FAILED
}